/**
 * Vanilla JavaScript Scroll to Element
 */

export default function scrollToElement(el) {
    /* eslint-disable */
    const smoothScroll = function (targetEl, duration) {
        const headerElHeight = document.querySelector('#header-nav').clientHeight + 24;
        const target = document.querySelector(targetEl);
        const targetPosition = target.getBoundingClientRect().top - headerElHeight;
        const startPosition = window.pageYOffset;
        let startTime = null;
        /* eslint-disable */
        const ease = function (t, b, c, d) {
            // eslint-disable-next-line no-param-reassign
            t /= d / 2;
            if (t < 1) return (c / 2) * t * t + b;
            // eslint-disable-next-line no-param-reassign
            t--;
            return (-c / 2) * (t * (t - 2) - 1) + b;
        };

        // eslint-disable-next-line func-names
        // eslint-disabled-func-names
        const animation = function (currentTime) {
            if (startTime === null) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const run = ease(timeElapsed, startPosition, targetPosition, duration);
            window.scrollTo(0, run);
            if (timeElapsed < duration) requestAnimationFrame(animation);
        };
        requestAnimationFrame(animation);
    };

    smoothScroll(el, 400);
}
